import { useQuery } from "@tanstack/react-query";
import { AlertSchema } from "../../types";
import { alertSchemaService } from "../../services/alertSchemasService";

export const useAlertProviders = () => {
  return useQuery<AlertSchema[]>({
    queryKey: ["alert-providers"],
    queryFn: async () => alertSchemaService.list(),
  });
};

